/**
 * Donut
 *
 * Inline-SVG donut chart. No chart library per CONSTITUTION.
 * Copied from user app's RevenueCustomerHealthPanel.tsx pattern.
 */

interface DonutSlice {
  label: string;
  value: number;
  color: string;
}

interface DonutProps {
  slices: DonutSlice[];
  size?: number;
  thickness?: number;
}

export function Donut({ slices, size = 140, thickness = 28 }: DonutProps) {
  const radius = (size - thickness) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;

  const total = slices.reduce((s, sl) => s + sl.value, 0) || 1;

  let offset = 0;
  const arcs = slices.map((sl) => {
    const pct = sl.value / total;
    const dash = pct * circumference;
    const gap = circumference - dash;
    const rotation = (offset / total) * 360 - 90;
    offset += sl.value;
    return { ...sl, dash, gap, rotation };
  });

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={slices.map((s) => `${s.label}: ${((s.value / total) * 100).toFixed(1)}%`).join(', ')}
    >
      {total === 0 ? (
        <circle cx={cx} cy={cy} r={radius} fill="none" stroke="#3f3f46" strokeWidth={thickness} />
      ) : (
        arcs.map((arc) => (
          <circle
            key={arc.label}
            cx={cx}
            cy={cy}
            r={radius}
            fill="none"
            stroke={arc.color}
            strokeWidth={thickness}
            strokeDasharray={`${arc.dash} ${arc.gap}`}
            transform={`rotate(${arc.rotation} ${cx} ${cy})`}
          />
        ))
      )}
    </svg>
  );
}
